module.exports = __webpack_public_path__ + "img/sd.ca07f3eb.png";